
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
import { Aemet } from "@/types/aemet.type";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import AemetFormComponent from "@/components/aemet/AemetForm.component.vue";
import AemetListComponent from "@/components/aemet/AemetList.component.vue";
import { errorHandlerDefault } from "@/utils/handler.util";

export default defineComponent({
  components: {
    PageButtonsComponent,
    AemetFormComponent,
    AemetListComponent,
  },
  data() {
    return {
      showAemetForm: false,
      aemetForm: undefined as undefined | Aemet,
    };
  },
  methods: {
    openAemetFormDialog() {
      this.showAemetForm = true;
    },
    closeAemetFormDialog() {
      this.showAemetForm = false;
    },
    async saveAemetForm() {
      await (this.$refs["aemetForm"] as InstanceType<typeof AemetFormComponent>)
        .doSave()
        ?.then(() => {
          // - close dialog and refresh
          this.closeAemetFormDialog();
          (this.$refs["aemetList"] as InstanceType<typeof AemetListComponent>).refreshItems();
          ElMessage.success(this.$t("success.action"));
        })
        .catch(errorHandlerDefault);
    },
  },
});
